
















// input: HTMLInputElement

export default {
  name: 'vue-book-input',
  data () {
    return {
      temporaryValue: '',
    }
  },
  props: {
    type: {
      type: String,
      default: 'default',
    },
    name: {
      type: String,
      default: 'default',
    },
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    tooltip: {
      type: String,
      default: '',
    },
  },
  computed: {
    valueProxy: {
      get () {
        if (this.value !== this.temporaryValue) {
          this.temporaryValue = this.value
        }
        return this.temporaryValue
      },
      set (value: string) {
        this.temporaryValue = value
        this.$nextTick(() => {
          if (this.value !== this.temporaryValue) {
            this.temporaryValue = this.value
          }
        })
        this.$emit('input', value)
      },
    },
  },
}
